/**
 * @generated SignedSource<<707c4608cf6a78b0a515b12f315e078f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MergeRulesInputObject = {
  excludeTxnIds?: ReadonlyArray<string> | null | undefined;
  matchKind?: string | null | undefined;
  overrideTxnIds?: ReadonlyArray<string> | null | undefined;
  regex?: string | null | undefined;
  ruleIds: ReadonlyArray<string>;
};
export type rulesPage_MergeRulesMutation$variables = {
  input: MergeRulesInputObject;
};
export type rulesPage_MergeRulesMutation$data = {
  readonly mergeRules: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type rulesPage_MergeRulesMutation = {
  response: rulesPage_MergeRulesMutation$data;
  variables: rulesPage_MergeRulesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_MergeRulesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MergeRulesMutationPayload",
        "kind": "LinkedField",
        "name": "mergeRules",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_MergeRulesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MergeRulesMutationPayload",
        "kind": "LinkedField",
        "name": "mergeRules",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d91241e1413d34f68c50ae554ac569c5",
    "id": null,
    "metadata": {},
    "name": "rulesPage_MergeRulesMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_MergeRulesMutation(\n  $input: MergeRulesInputObject!\n) {\n  mergeRules(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "785c187f8566153f6aa7c54be7721813";

export default node;
